import { gql } from '@apollo/client';

export const GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM = gql`
  query GetTagesDaten($standortIds: [String!]!, $zeitraum: ZeitraumInput!) {
    termine_termineKalenderByStandortIdAndZeitraum(
      standortIds: $standortIds
      zeitraum: $zeitraum
    ) {
      id
      kalenderSchluessel
      name
      idStandort
      markierung
      termine {
        id
        standortId
        titel
        datum
        beginn
        ende
        terminKalenderId
        image {
          name
          contentType
          url
          thumbnailUrl
        }
        markierung
        termineDetails {
          beschreibung
          specials
        }
        wiederholung
        wiederholungBis
        hasHiddenArbeitszeiten
        termine_arbeitszeiten {
          id
          datum
          beginn
          ende
          arbeitsbereich {
            markierung
            name
          }
          mitarbeiter {
            id
            vorname
            nachname
            bildUrl
          }
        }
        hasHiddenSchichten
        termine_schichten {
          id
          name
          datum
          beginn
          ende
          markierung
          termine_arbeitsbereich {
            markierung
            name
          }
          termine_mitarbeiter {
            bildUrl
            id
            nachname
            vorname
          }
        }
      }
    }
    termine_feiertageByStandortIdsAndZeitraum(
      standortIds: $standortIds
      zeitraum: $zeitraum
    ) {
      name
      datum
    }
  }
`;

export const GET_TERMINE_KALENDER_BY_STANDORTID_AND_ZEITRAUM = gql`
  query GetTermineKalenderByStandortIdAndZeitraum(
    $standortIds: [String!]!
    $zeitraum: ZeitraumInput
  ) {
    termine_termineKalenderByStandortIdAndZeitraum(
      standortIds: $standortIds
      zeitraum: $zeitraum
    ) {
      id
      kalenderSchluessel
      name
      idStandort
      markierung
      termine {
        id
        datum
      }
    }
  }
`;
